import React from 'react'

function BreadCrumbs() {
    // const date = new Date();
    const formattedDate = new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <div className="custFlexBetween mb-5">
            <div className="breadcrumbs text-sm">
                <ul>
                    <li><a className='text-primary'>Mandap Booking</a></li>
                    <li className='text-base-content'>Dashboard</li>
                </ul>
            </div>

            <div className="timeCont">
                <p className='text-base-content text-sm'>{formattedDate}</p>
            </div>
        </div>

    )
}

export default BreadCrumbs